import { useTranslation } from 'react-i18next';

import { PrivateAccess } from '@wf/keycloak-axios-provider';
import { Label } from '@wf/sw-ui-kit';

import Separator from '../../../../components/Separator';
import { LicenseField } from '../LicenseField';

import { NamesAndPartiesTabFields } from '../../types/fieldEnums';
import { declarantRoles } from '../../../../constants';

interface IDeclarantFieldProps {
  disabled: boolean;
}

function DeclarantFields({ disabled }: IDeclarantFieldProps) {
  const { t } = useTranslation();

  return (
    <PrivateAccess roles={declarantRoles}>
      <LicenseField.TextField
        label={
          <Label
            helpText={t(
              'Unique identifier assigned to the Declarant by Customs Authorities for customs declaration purposes'
            )}
          >
            {t('Declarant Code')}
          </Label>
        }
        configName={NamesAndPartiesTabFields.declarantCode}
        name={NamesAndPartiesTabFields.declarantCode}
        placeholder={t('Declarant Code')}
        disabled
      />
      <LicenseField.TextField
        label={
          <Label
            helpText={t(
              'Name of the individual or entity authorized to file the declaration and supporting documentation to Customs Authorities'
            )}
          >
            {t('Declarant Name')}
          </Label>
        }
        configName={NamesAndPartiesTabFields.declarantName}
        name={NamesAndPartiesTabFields.declarantName}
        placeholder={t('Declarant Name')}
        {...(disabled ? { disabled: true } : undefined)}
      />
      <Separator className="grid-full-width" />
    </PrivateAccess>
  );
}

export default DeclarantFields;
